<template>
  <div @click="select_event" class="px-2 mb-1 mt-1" :style="Skin.menu_live.event_fondo+'cursor:pointer'">
    <div class="d-flex">
      <div style="width:10%">
        <span :style="hover ? Skin.menu_live.sport_count : Skin.menu_live.event_text">
          <i v-if="!encuentro.favorite" @mouseover="hover = true" @mouseleave="hover = false" @click="addFavorito" class="far fa-star"></i>
          <i v-else @click="removeFavorito" class="fas fa-times"></i>
        </span>
      </div>
      <div class="" style="width:80%">
        <span class="long_text" :style="Skin.menu_live.event_text" style="font-size:x-small">{{ game_state(encuentro.info.current_game_state,encuentro.sport) }} {{ encuentro.info.current_game_time != 0 ? encuentro.info.current_game_time : "" }}</span>
      </div>
      <div style="width:10%">
        <span title="Number of Markets" class="market_count" :style="Skin.menu_live.event_odds_count">
          <span v-if="encuentro.markets_count == 0" style="font-size:xx-small"><i  class="fas fa-lock"></i></span>
          <span v-else>+{{ encuentro.markets_count }}</span>
        </span>
      </div>
    </div>
    <div class="d-flex">
      <div style="width:90%;">
        <span :style="Skin.menu_live.event_text" class="long_text">{{ encuentro.team1_name  }}</span>
      </div>
      <div style="width:10%">
        <span :style="Skin.menu_live.sport_count">{{ encuentro.info ? encuentro.info.score1 : "" }}</span>
      </div>
    </div>
    <div class="d-flex">
      <div style="width:90%;">
        <span :style="Skin.menu_live.event_text" class="long_text">{{ encuentro.team2_name  }}</span>
      </div>
      <div style="width:10%">
        <span :style="Skin.menu_live.sport_count">{{ encuentro.info ? encuentro.info.score2 : "" }}</span>
      </div>
    </div>
  </div>
</template>
<script>
export default{
  name:"eventoEncuentroLive",
  data(){
    return {
      hover: false,
    }
  },
  props:['encuentro','Skin','translation','language'],
  methods:{
    select_event(){
      if(this.$store.getters['live/getTargetEventId'] !=  this.$props.encuentro.id){
        if(Object.keys(this.$store.getters['live/getLiveEvent']).length > 0){
          this.$store.dispatch('live/unsuscribe_event');
        }
        this.$store.dispatch('live/suscribe_event', this.$props.encuentro.id);
      }
      this.$store.dispatch('setLobbyView','live');
    },
    addFavorito(){
      this.$store.dispatch('live/addFavorite', this.$props.encuentro);
    },
    removeFavorito(){
      this.$store.dispatch('live/removeFavorite', this.$props.encuentro);
    },
    translate(text) {
      if(text){
        if (this.$props.translation[text]) {
            return this.$props.translation[text][this.$props.language];
        }
        else{
          var new_text_serched = text.replace(/ /g, "_");
          if (this.$props.translation[new_text_serched]) {
              return this.$props.translation[new_text_serched][this.$props.language];
          }
        }
      }
      return text;
    },
    game_state(state,sport){
      switch (sport) {
          case 1:
              if(state == "set1"){
                  return this.translate('set1_soccer');
              }
              else if(state == "set2"){
                  return this.translate('set2_soccer')
              }
              else if(state == "set3"){
                  return this.translate('set3_soccer')
              }
              else if(state == "set4"){
                  return this.translate('set4_soccer')
              }
              else if(state == "set5"){
                  return this.translate('set5_soccer')
              }
              else if(state == "Half Time"){
                  return this.translate('half_time_soccer')
              }
              else if(state == "notstarted"){
                  return this.translate('notstarted')
              }
              else if(state == "timeout"){
                  return this.translate('timeout_soccer')
              }
              break;
          case 3:
              if(state == "set1"){
                  return this.translate('set1_basket')
              }
              else if(state == "set2"){
                  return this.translate('set2_basket')
              }
              else if(state == "set3"){
                  return this.translate('set3_basket')
              }
              else if(state == "set4"){
                  return this.translate('set4_basket')
              } 
              else if(state == "timeout"){
                  return this.translate('timeout_basket')
              }
              else if(state == "notstarted"){
                  return this.translate('notstarted')
              }
              break
          case 11:
              if(state == "set1"){
                  return "1er Inning"
              }
              else if(state == "set2"){
                  return "2do Inning"
              }
              else if(state == "set3"){
                  return "3er Inning"
              }
              else if(state == "set4"){
                  return "4to Inning"
              } 
              else if(state == "set5"){
                  return "5th Inning"
              } 
              else if(state == "set6"){
                  return "6th Inning"
              } 
              else if(state == "set7"){
                  return "7th Inning"
              } 
              else if(state == "set8"){
                  return "8th Inning"
              } 
              else if(state == "set9"){
                  return "9th Inning"
              } 
              else if(state == "set10"){
                  return "10th Inning"
              } 
              else if(state == "timeout"){
                  return "Timeout"
              }
              else if(state == "notstarted"){
                  return this.translate('notstarted')
              }
              break
          case 4:
              return state;
          case 2:
              if(state == "set1"){
                  return this.translate('set1_soccer');
              }
              else if(state == "set2"){
                  return this.translate('set2_soccer');
              }
              else if(state == "set3"){
                  return this.translate('set3_hockey');
              }
              else if(state == "notstarted"){
                  return this.translate('notstarted');
              }
              else if(state == "timeout"){
                  return this.translate('timeout_soccer');
              }
          default:
              return state
      }
    }
  },
  mounted(){
    

  }
}
</script>
<style scoped>
  .long_text {
      display: -webkit-box;
      max-width: 200px;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
  }
  .market_count{
    box-sizing: border-box;
    display: inline-block;
    background: #262626;
    font: 11px/12px Arial,Helvetica,sans-serif;
    padding: 1px;
    width: 30px;
    text-align: center;
    border-radius: 3px;
    vertical-align: center;
  }
</style>
